import { useQuery } from "convex/react";
import { api } from "@todotogether/backend/_generated/api";

/**
 * Diagnostics route (/health, ticket #178): the deploy gate's seam. The
 * element renders only once the browser's Convex client resolves the
 * query, so its visibility proves the SERVED SPA talks to the live
 * deployment — the whole-stack check the prod deploy smoke reads (a web
 * bundle baked with the wrong backend URL dies right here). Deliberately
 * not on the landing page: users get a clean front door; the gate reads
 * /health.
 */
function DeploymentStatus() {
  const status = useQuery(api.health.getDeploymentStatus);
  if (status === undefined) {
    return <p className="text-muted">Connecting…</p>;
  }
  return (
    <p className="text-ink" data-testid="deployment-status">
      Live from Convex <span className="font-semibold">{status.region}</span> ·
      synced {new Date(status.serverTime).toISOString().slice(0, 16)}Z
    </p>
  );
}

export default function Health() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-paper px-6">
      <DeploymentStatus />
    </main>
  );
}
